'use strict';

const smartAdserverManager = require('node-smartadserver-dmp');

module.exports = function(angular, app) {
	app.service('smartAdserverManager', [() => smartAdserverManager]);
};
